import { NgModule } from '@angular/core';
import { GlobalModule } from '../global/global.module';
import { PagePartnerComponent } from './partner/partner.component';
import { UIRouterModule } from '@uirouter/angular';
import { STATES } from './pages.states';
import { PageJimButtonComponent } from './jimButton/jimButton.component';
import { PageEndeComponent } from './ende/ende.component';
import { PageFaqComponent } from './faq/faq.component';
import { PageImprintComponent } from './imprint/imprint.component';

@NgModule({
  declarations: [
    PagePartnerComponent,
    PageJimButtonComponent,
    PageEndeComponent,
    PageImprintComponent,
    PageFaqComponent
  ],
  imports: [
    GlobalModule,
    UIRouterModule.forChild({states: STATES})
  ]
})
export class PagesModule {
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts